import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleModelService } from '../services/vehicle-model.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrl: './add-vehicle.component.css',
})
export class AddVehicleComponent implements OnInit {
  vehicleForm: FormGroup = new FormGroup({});

  constructor(
    private fb: FormBuilder,
    private vehicleModelService: VehicleModelService,
  ) {
    // do nothing
  }
  ngOnInit(): void {
    this.vehicleForm = this.fb.group({
      typevehicle: ['', Validators.required],
      marca: ['', Validators.required],
      modelo: ['', Validators.required],
      km: ['', [Validators.required]],
      plate: ['', Validators.required],
      color: ['', Validators.required],
      year: ['', Validators.required],
      city: ['', Validators.required],
    });

    this.vehicleModelService.getVehicleModels().subscribe((data) => {
      console.log(data);
    });
  }

  onSubmit() {
    window.location.reload();
    if (this.vehicleForm.valid) {
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Vehículo registrado correctamente',
        confirmButtonText: 'Aceptar',
      });
      //   console.log('Datos del vehículo:', this.vehicleForm.value);
      this.vehicleModelService.createVehicleModel(this.vehicleForm.value).subscribe((data) => {
        console.log('data', data);
      });
    } else {
      console.log('Formulario inválido, ¡corrige los errores! 😅');
      //   console.log(this.vehicleForm.value);
    }
  }

  selectColor(color: string): void {
    this.vehicleForm.get('color')?.setValue(color);
  }
}
